import React, { useState } from 'react'
import { Button } from '../../../theme/common'
import { PoweredByDavipayLogo } from '../../../assets/svg'
import { useHistory } from 'react-router-dom'
import { DataService } from '../../../services/dataService'
import { useSelector } from 'react-redux'
import { RootState } from '../../../redux/reducers'
import { UserReducerType } from '../../../types'
import {
  ContainerDataTransaction,
  TitleDataTransaction,
  DivRightDataTransaction,
  DivLeftDataTransaction,
  DivTableDataTransaction,
  DivContainerTable,
  DivFooterDataTransaction,
  TransactionDataContainer,
  Space,
} from './styles'

const TransactionData = ({ data }: any) => {
  const userState: UserReducerType = useSelector((state: RootState) => state.user)
  const history = useHistory()

  const [loading, setLoading] = useState(false)

  const getReport = () => {
    setLoading(true)
    const dataService = new DataService()
    dataService
      .post('/miepayco/payment/receipt', {
        id: data.ref_payco,
        url: userState.subdomain || window.location.origin,
      })
      .then((response) => {
        const file = response?.data?.data?.file || response?.data?.data?.data?.file
        if (response.status && file) {
          openReportPDF(file)
        }
        setLoading(false)
      })
      .catch((e) => {
        console.log(e)
        setLoading(false)
      })
  }

  const openReportPDF = (base64: string) => {
    const base64Data = base64.includes(',') ? base64.split(',')[1] : base64
    const byteCharacters = atob(base64Data)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: 'application/pdf' })
    const blobUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = `comprobante_${data.ref_payco}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(blobUrl)
  }

  return (
    <TransactionDataContainer>
      <ContainerDataTransaction>
        <TitleDataTransaction>Detalle de la transacción</TitleDataTransaction>
        <DivContainerTable>
          <DivTableDataTransaction>
            <DivLeftDataTransaction>Referencia Davipay</DivLeftDataTransaction>
            <DivLeftDataTransaction>Fecha y hora</DivLeftDataTransaction>
            <DivLeftDataTransaction>Medio de pago</DivLeftDataTransaction>
            <DivLeftDataTransaction>Autorización</DivLeftDataTransaction>
            <DivLeftDataTransaction>Nro Recibo</DivLeftDataTransaction>
          </DivTableDataTransaction>

          <DivTableDataTransaction>
            <DivRightDataTransaction>{data.ref_payco}</DivRightDataTransaction>
            <DivRightDataTransaction>{data.transaction_date}</DivRightDataTransaction>
            <DivRightDataTransaction>{data.franchise}</DivRightDataTransaction>
            <DivRightDataTransaction>{data.approval_code}</DivRightDataTransaction>
            <DivRightDataTransaction>{data.id_invoice}</DivRightDataTransaction>
          </DivTableDataTransaction>
        </DivContainerTable>
      </ContainerDataTransaction>

      <DivFooterDataTransaction>
        {data.status === 'ACEPTADA' || data.status === 'PENDIENTE' ? (
          <>
            {data.status === 'ACEPTADA' && (
              <>
                <Button type="button" typeBottom="secondary" onClick={getReport} loading={loading}>
                  Ver comprobante
                </Button>
                <Space />
              </>
            )}
            <Button
              type="button"
              onClick={() => userState.subdomain && window.location.replace(userState.subdomain)}
            >
              Realizar otro pago
            </Button>
          </>
        ) : (
          <Button type="button" onClick={() => history.push('/')}>
            Reintentar transacción
          </Button>
        )}
        <Space />
        <PoweredByDavipayLogo style={{ marginTop: '.8rem' }} />
      </DivFooterDataTransaction>
    </TransactionDataContainer>
  )
}

export default TransactionData
